import { Box, Tooltip } from '@mantine/core'
import { ArrowUpRight } from 'lucide-react'

import { routes } from '@redwoodjs/router'
import { Link } from '@redwoodjs/router'

import Tag from 'src/components/DataDisplay/Tag/Tag'
import { buildFullName } from 'src/lib/formatters'

const ONE_DAY_MS = 24 * 60 * 60 * 1000

const ApplicantContentCell = ({ applicant }) => {
  const tooltipText = `View ${buildFullName(applicant)}'s profile`

  const isReapply =
    !!applicant.applicationDate &&
    !!applicant.createdAt &&
    new Date(applicant.applicationDate).getTime() -
      new Date(applicant.createdAt).getTime() >
      ONE_DAY_MS

  const showOptOutIndicator = applicant.isCommunicationOptIn === false
  const showCallIndicator =
    !applicant.lastContactDate && !applicant.lastActionDate
  const contactTooltip = showOptOutIndicator
    ? 'Applicant has opted out of communications'
    : showCallIndicator
      ? 'Applicant has not been contacted yet'
      : null

  return (
    <div className="flex min-w-0 flex-1 flex-col gap-0.5">
      <Box
        component={Link}
        onClick={(e) => {
          e.stopPropagation()
        }}
        to={routes.applicantDetails({
          id: applicant.applicantId,
          tab: 'application',
        })}
        className="flex w-full flex-row items-center justify-between whitespace-nowrap text-xs font-medium text-doubleNickel-gray-900 hover:cursor-pointer"
      >
        <Tooltip label={tooltipText}>
          <div className="max-w-52 truncate">
            {applicant.firstName} {applicant.middleName} {applicant.lastName}
          </div>
        </Tooltip>
        <div className="ml-auto flex flex-shrink-0 items-center gap-1.5">
          {isReapply && (
            <Tooltip label="Has applied to this company before" withArrow>
              <span className="h-1.5 w-1.5 rounded-full bg-doubleNickel-warning-300" />
            </Tooltip>
          )}
          {contactTooltip && (
            <Tooltip label={contactTooltip} withArrow>
              <span
                aria-label={contactTooltip}
                className={`h-1.5 w-1.5 rounded-full ${
                  showOptOutIndicator
                    ? 'bg-doubleNickel-error-500'
                    : 'bg-doubleNickel-brand-500'
                }`}
              />
            </Tooltip>
          )}
          <span className="flex items-center justify-center rounded p-1 text-doubleNickel-gray-400 hover:bg-doubleNickel-gray-100 hover:text-doubleNickel-brand-500">
            <ArrowUpRight className="h-3 w-3" />
          </span>
        </div>
      </Box>
      {applicant?.automationsEnabled === false && (
        <Tooltip label="Automations are off for this applicant" withArrow>
          <div className="w-fit">
            <Tag size="xs" variant="warning" showCloseButton={false}>
              Automations Off
            </Tag>
          </div>
        </Tooltip>
      )}
    </div>
  )
}

export default ApplicantContentCell
